import { shallowEqual, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import {
  queryPriceData,
  getQueryKey as getPriceDataQueryKey,
  getDefault,
} from '../queryPriceData';
import {
  queryPriceTargets,
  getQueryKey as getPriceTargetsQueryKey,
  getDefaultResponse,
} from '../queryPriceTargets';
import { selector as valuationSelector } from '@/pages/CompanyReport/components/Valuation';

export default function useAnalystPriceTargets() {
  const valuationData = useSelector<
    Parameters<typeof valuationSelector>[0],
    ReturnType<typeof valuationSelector>
  >(valuationSelector, shallowEqual);
  const {
    data: priceTarget = getDefaultResponse(),
    status: priceTargetStatus,
  } = useQuery({
    queryKey: getPriceTargetsQueryKey(valuationData.canonicalUrl ?? ''),
    queryFn: queryPriceTargets,
    enabled: Boolean(valuationData.canonicalUrl),
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    keepPreviousData: true,
  });
  const { data: priceData = getDefault(), status: priceDataStatus } = useQuery({
    queryKey: getPriceDataQueryKey(valuationData.canonicalUrl ?? ''),
    queryFn: queryPriceData,
    enabled: Boolean(valuationData.canonicalUrl),
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    keepPreviousData: true,
  });
  return {
    priceTarget,
    priceData,
    priceTargetStatus,
    priceDataStatus,
  };
}
